<template>
  <div
    class="flex flex-col md:flex-row h-[399px] md:border-b-[30px] md:border-primary md:after:bottom-0 md:after:border-b-[16px] md:after:border-primary-100/60 md:after:w-full md:after:block md:after:absolute relative text-white"
  >
    <div class="basis-1/2 relative md:overflow-hidden">
      <!-- TODO FIX imgSrc -->
      <NuxtImg
        loading="lazy"
        :src="imgSrc"
        class="w-[50%] md:w-full h-[118px] md:h-full md:max-h-60 -mb-2 md:mb-0 md:left-0 left-[1.5rem] md:right-0 md:absolute 2xl:left-20 z-10"
        :class="imgStyle"
        alt="img"
      />
    </div>
    <!-- div for desktop site -->
    <div
      class="hidden md:flex flex-col mix-blend-darken z-10 bottom-circle basis-1/2 justify-center relative md:border-b-[360px] border-b-primary border-l-[70px] border-l-white"
    >
      <div class="absolute top-20 left-6 lg:left-12 right-4">
        <div v-if="getStarted">
          <div
            class="mb-8 font-bold text-[27px] lg:text-[37px] leading-[1.3] md:max-w-[420px]"
            v-html="$t('clinic.ctaBlock.title1')"
          ></div>
          <BaseButton :text="$t('common.btnGetStarted')" class="w-80 mb-2" @click="onCardClick()"></BaseButton>
        </div>
        <div v-else>
          <h3 class="text-[27px] lg:text-[37px] leading-[1.3] text-white" v-html="$t('clinic.ctaBlock.title2')"></h3>
          <ul class="intro-text space-y-2 mt-8">
            <li class="flex">
              <NuxtImg
                loading="lazy"
                src="/icons/checkmark-white.svg"
                alt="checkmark"
                class="mr-3"
                width="20"
                height="30"
              />
              {{ $t("clinic.ctaBlock.subTitle1") }}
            </li>
            <li class="flex">
              <NuxtImg
                loading="lazy"
                src="/icons/checkmark-white.svg"
                alt="checkmark"
                class="mr-3"
                width="20"
                height="30"
              />
              {{ $t("clinic.ctaBlock.subTitle2") }}
            </li>
            <li class="flex">
              <NuxtImg
                loading="lazy"
                src="/icons/checkmark-white.svg"
                alt="checkmark"
                class="mr-3"
                width="20"
                height="30"
              />
              {{ $t("clinic.ctaBlock.subTitle3") }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- div for mobile site -->
    <div class="md:hidden bg-primary">
      <div class="px-5 py-10">
        <div v-if="getStarted" class="pt-4">
          <div
            class="px-4 md:px-0 mb-8 mx-auto font-bold text-[27px] leading-[1.4] max-w-[340px] text-center"
            v-html="$t('clinic.ctaBlock.title1')"
          ></div>
          <BaseButton :text="$t('common.btnGetStarted')" class="w-full py-6" @click="onCardClick()"></BaseButton>
        </div>
        <div v-else>
          <h3 class="text-[37px] leading-[48px] text-white" v-html="$t('clinic.ctaBlock.title2')"></h3>
          <ul class="intro-text space-y-2 mt-8">
            <li class="flex items-start">
              <NuxtImg
                loading="lazy"
                src="/icons/checkmark-white.svg"
                alt="checkmark"
                class="mr-3 mt-2 w-5 shrink-0"
                width="20"
                height="30"
              />
              <span>{{ $t("clinic.ctaBlock.subTitle1") }}</span>
            </li>
            <li class="flex items-start">
              <NuxtImg
                loading="lazy"
                src="/icons/checkmark-white.svg"
                alt="checkmark"
                class="mr-3 mt-2 w-5 shrink-0"
                width="20"
                height="30"
              />
              <span>{{ $t("clinic.ctaBlock.subTitle2") }}</span>
            </li>
            <li class="flex items-start">
              <NuxtImg
                loading="lazy"
                src="/icons/checkmark-white.svg"
                alt="checkmark"
                class="mr-3 mt-2 w-5 shrink-0"
                width="20"
                height="30"
              />
              <span>{{ $t("clinic.ctaBlock.subTitle3") }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  getStarted: {
    type: Boolean,
  },
  imgSrc: {
    type: String,
    default: "Benefits-of-regular-testing",
  },
});
const router = useRouter();
const imgSrc = ref("");
const imgStyle = computed(() => {
  return props.getStarted ? "bottom-0 md:bottom-4" : "md:bottom-0 -bottom-3";
});

const onCardClick = () => {
  return navigateTo(localeUri(`/get-started`));
};

watchEffect(() => {
  imgSrc.value = `/img/${props.imgSrc}.svg`;
});
</script>

<style scoped>
.bottom-circle:before {
  content: "";
  bottom: calc(-2 * 2rem);
  left: -2px;
  position: absolute;
  height: calc(2 * 2rem);
  width: 2rem;
  /* background-color: transparent; */
  border-top-left-radius: 10px;
  box-shadow: white 0px calc(-1 * 2rem) 0px -1px;
}
</style>
